import { useAppSelector } from "@src/store/hooks";

/**
 * Phase d'attente avant de considérer le setup comme « terminé » pour l'UI :
 * - `critical` : configs Gatsby sur `app` (bootstrap pré-setupweb)
 * - `initialized` : `app.setupObjects()` terminé (produits, catégories, stores…)
 * - `ready` : `cart.setup()` terminé (panier prêt)
 */
export type AfterSetupPhase = "critical" | "initialized" | "ready";

export type UseLoadAfterSetupOptions = {
  phase?: AfterSetupPhase;
};

const useLoadAfterSetup = (options?: UseLoadAfterSetupOptions) => {
  const phase = options?.phase ?? "initialized";
  const criticalConfigReady = useAppSelector(
    (state) => state.app.criticalConfigReady
  );
  const setupInitialized = useAppSelector(
    (state) => state.app.setupInitialized
  );
  const setupReady = useAppSelector((state) => state.app.setupReady);

  if (phase === "critical") {
    return criticalConfigReady;
  }
  if (phase === "ready") {
    return setupReady;
  }
  return setupInitialized;
};

export default useLoadAfterSetup;
